import React from "react";

import { localizedText } from "shared/lib/localizedMap";
import { ChipToggle, LabeledField, Select } from "shared/ui";

import { useCouponsContext } from "features/Coupons/context";
import { CouponsTypeFilter } from "features/Coupons/types";

import { Bar, Chips, MenuField } from "./styles";

const TYPE_FILTERS: { value: CouponsTypeFilter; label: string }[] = [
    { value: null, label: "Все" },
    { value: "Percentage", label: "Скидка в процентах" },
    { value: "FixedAmount", label: "Скидка суммой" },
];

export const CouponsFilters = () => {
    const state = useCouponsContext();

    return (
        <Bar>
            <MenuField>
                <LabeledField label="Меню" htmlFor="coupons-menu">
                    <Select
                        id="coupons-menu"
                        value={state.menuId}
                        onChange={(value) => state.setMenuId(Number(value))}
                        options={state.menuOptions.map((menu) => ({
                            value: menu.id,
                            label: localizedText(menu.name, state.locale),
                        }))}
                    />
                </LabeledField>
            </MenuField>

            <Chips>
                {TYPE_FILTERS.map((filter) => (
                    <ChipToggle
                        key={filter.label}
                        active={state.typeFilter === filter.value}
                        onClick={() => state.setTypeFilter(filter.value)}
                    >
                        {filter.label}
                    </ChipToggle>
                ))}
            </Chips>
        </Bar>
    );
};
